import { map, catchError } from 'rxjs/operators';
import { HttpInitService } from './httpinit.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseURL } from '../vay.config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MingoErrorsHandler } from './errors-handler.service';
import { VayAntService } from './vay-ant.service';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private _data = new BehaviorSubject<any>({});
  public _plans = new BehaviorSubject<any>({});
  private _dataSlider = new BehaviorSubject<any>({});
  settings = this._data.asObservable();
  slider = this._dataSlider.asObservable();
  getHelpData: any;
  constructor(
    private httpInit: HttpInitService,
    private https: HttpClient,
    private mingoErrorsHandler: MingoErrorsHandler,
    private antService: VayAntService,
    private languageService: LanguageService
  ) {}

  getSettings() {
    this.httpInit.getRequest(`${BaseURL}/api/settings/frontend`).subscribe((data: any) => {
      this._data.next(data.settings);
    });
  }

  getPlans(id: string) {
    this.httpInit
      .getRequestWithParams(`${BaseURL}/api/plan/country/currentcountry`, { countryId: id })
      .subscribe((data: any) => {
        if (data.data[0]) {
          this._plans.next(data);
          this.languageService.country.next(data.data[0].country);
        }
      });
  }

  getSlider(_params: any) {
    // this.httpInit.getRequest(`${BaseURL}/api/slider/frontend`).subscribe(res => {
    //   // this._dataSlider.next(res);
    //   return res;
    // });
    let params = new HttpParams();
    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });
    return this.https
      .get(`${BaseURL}/api/slider/frontend`, { params })
      .pipe(catchError((e: any) => this.mingoErrorsHandler.handleError(e))) as Observable<any>;
  }

  getHelpService(data: any) {
    return this.https.post(`${BaseURL}/api/gethelp`, data).pipe(
      map((res: any) => {
        this.getHelpData = res;
        this.antService.showMessage('Send Successfully');
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  }
}
